import { OAUTH_API } from '@/services/Configuration'
import Axios from 'axios'

import { standardizeAddress } from '@/services/Standardizers'
import { isValidAddress } from '@/helpers'

// TODO: We need documentation regarding this API
export const getAddresses = async ({ email }) => ((await Axios.get(`${OAUTH_API}/sf/customer/addresses/${email}`)).data.data).map(standardizeAddress).filter(isValidAddress)
